import { render, staticRenderFns } from "./Closable.vue?vue&type=template&id=66d7e49b&"
import script from "./Closable.vue?vue&type=script&lang=js&"
export * from "./Closable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports